export type FillInDaBlanksTemplate = string;

export type FillInDaBlanksValues = Record<string, string | number>;

export function fillInDaBlanks(
  template: FillInDaBlanksTemplate,
  values: FillInDaBlanksValues,
): string {
  return template.replace(/{(.*?)}/g, (_, key) => {
    if (values[key] === undefined) {
      console.error(`[fillInDaBlanks] Missing value for: {${key}}`);
      return `{${key}}`;
    }
    return String(values[key]);
  });
}
